// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"a9395f09","outerContainer":"_217c7d91","secondaryToolbar":"_086dc1af","doorHangerRight":"d0d75d48","toolbarContainer":"ba35433c","toolbarViewerMiddle":"_0da187b7","progressBar":"_223fb7cf","back-to-application":"e9162c66","root":"bf16469e","avatar":"b4d2ad5f","preview":"_547c2374","info":"_53c768d3","status":"_39d73c35","truncate":"_5411a3f4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/InviteeView/styles.module.styl
// module id = 5156
// module chunks = 39